export default __webpack_public_path__ + "static/media/settings-sliders.219d3c4c.svg";